/**
 * Наступний доступний пункт списку для клавіш ↑ ↓ Home End: крок ±1 пропускає недоступні; на краях лишається на місці
 * (як у прототипі — без циклу). from = −1 означає «нічого не виділено».
 */
export function nextEnabledIndex(disabled: boolean[], from: number, step: 1 | -1 | 'first' | 'last'): number {
  const n = disabled.length;
  if (!n) return -1;
  if (step === 'first' || step === 'last') {
    const order = Array.from({ length: n }, (_, i) => (step === 'first' ? i : n - 1 - i));
    return order.find((i) => !disabled[i]) ?? -1;
  }
  for (let i = from + step; i >= 0 && i < n; i += step) if (!disabled[i]) return i;
  return from >= 0 && from < n && !disabled[from] ? from : nextEnabledIndex(disabled, -1, 'first');
}
